import type { Permission } from '@pulsepoint/shared';
import type { ReactNode } from 'react';
import { useMe } from '../api/auth';

/** Whether the signed-in person may do this. The API checks again; this only hides buttons. */
export function usePermission(p: Permission): boolean {
  const { data: me } = useMe();
  return !!me?.permissions.includes(p);
}

/** Shows its children only to people with the permission. */
export function Can({ permission, children }: { permission: Permission; children: ReactNode }) {
  return usePermission(permission) ? <>{children}</> : null;
}
